import { client } from './API';
import { ENVIRONMENTAL_VARIABLES } from '@/utils/Environment';

export const getStatus = ({
  communityId,
  roomId,
  boardId,
  exportId,
}: {
  communityId: string;
  roomId: string;
  boardId: string;
  exportId: string;
}): Promise<any> => {
  return client.get(
    `${ENVIRONMENTAL_VARIABLES.API_ALFRESCO_URL}/${communityId}/rooms/${roomId}/boards/${boardId}/exports/${exportId}/status`,
  );
};

export const download = ({
  communityId,
  roomId,
  boardId,
  exportId,
  targetFileName,
}: {
  communityId: string;
  roomId: string;
  boardId: string;
  exportId: string;
  targetFileName: string;
}): Promise<Blob> => {
  const config = {
    responseType: 'blob', // important
    params: { targetFileName },
  };

  return client.get(
    `${ENVIRONMENTAL_VARIABLES.API_ALFRESCO_URL}/${communityId}/rooms/${roomId}/boards/${boardId}/exports/${exportId}`,
    config as any,
  );
};

export const exportContent = ({
  communityId,
  roomId,
  boardId,
  exportRequest,
}: {
  communityId: string;
  roomId: string;
  boardId: string;
  exportRequest: any;
}): Promise<Blob> => {
  return client
    .post(
      `${ENVIRONMENTAL_VARIABLES.API_ALFRESCO_URL}/${communityId}/rooms/${roomId}/boards/${boardId}/exports`,
      exportRequest,
    )
    .then((response) => exportIterate(response, communityId, roomId, boardId, exportRequest.file_name));
};

const exportIterate = (
  response: any,
  communityId: string,
  roomId: string,
  boardId: string,
  targetFileName: string,
): Promise<Blob> => {
  const exportId = response.data.id;
  if (response.data.status !== 'DONE') {
    return new Promise((resolve) => {
      setTimeout(() => {
        return getStatus({ communityId, roomId, boardId, exportId }).then((statusResponse) =>
          resolve(exportIterate(statusResponse, communityId, roomId, boardId, targetFileName)),
        );
      }, 5000);
    });
  } else {
    return download({ communityId, roomId, boardId, exportId, targetFileName });
  }
};
